import React, { useEffect, useRef, useState } from "react";
/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import { useGetContractExpenseDetailsMutation } from "../../../../../../../app/services/contractAPI";

const ExpenseDetail = (props) => {
  const gridRef = useRef();
  const contractId = props.contractId;
  const repairKey = props.rowData.lRepairKey;
  const [gridData, setGridData] = useState([]);

  const [getAllContractExpenseList, {
    isSuccess: isAllContractExpenseFetched,
    data: AllContractExpenseData
  }] = useGetContractExpenseDetailsMutation();

  useEffect(() => {
    const request = {
      plContractKey: contractId,
      plRepairKey: repairKey,
    }
    getAllContractExpenseList(request);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  useEffect(() => {
    if (isAllContractExpenseFetched && AllContractExpenseData) {
      setGridData(AllContractExpenseData);
    }
  }, [isAllContractExpenseFetched, AllContractExpenseData]);

  const totalAmount = gridData?.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );

  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12 consumption-detail-model">
          <MolGrid
            ref={gridRef}
            value={gridData}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
          >
            <Column field="expenseReason" header="Expense" grouping sortable />
            <Column field="amount" body={(rowData) => {
              const value = Number(rowData?.amount) || 0;
              return `$${value.toFixed(2)}`;
            }} header="Amount"
              footer={`$${totalAmount.toFixed(2)}`}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </div>
    </>
  );
};
export default ExpenseDetail;
